<div class="-menu-asset">
  @if (icon) {
  <lucide-icon [name]="icon" class="menu-item-icon"></lucide-icon>
  }
</div>
<div class="-menu-block">
  <div class="-menu-header">
    <h3>{{ name }}</h3>
    <app-indicator-chip-wrapper [indicator]="indicator"></app-indicator-chip-wrapper>
  </div>
  <p>{{ description }}</p>
</div>
